import styled from 'styled-components';

export const LoaderWrapper = styled.div`
    display: flex;
    min-height: 36px;
    justify-content: center;
    align-items: center;

    & #interstitial-overlay-root {
        background-color: transparent;
        min-width: 32px;
        min-height: 36px;
    }
    & #interstitial-content-root {
        min-width: 32px;
        box-shadow: none;
    }
`;
